import * as _general from './general/actions';
import * as _team from './team/actions';
import * as _sprint from './sprint/actions';
import * as _user from './user/actions';
import * as _itemType from './itemType/actions';
import * as _status from './status/actions';
import * as _tag from './tag/actions';
import * as _board from './board/actions';
import * as _category from './category/actions';
import * as _template from './template/actions';

export const general = _general;
export const team = _team;
export const sprint = _sprint;
export const user = _user;
export const itemType = _itemType;
export const status = _status;
export const tag = _tag;
export const board = _board;
export const category = _category;
export const template = _template;



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/actions.js